import { useParams, useNavigate } from 'react-router-dom';
import { useConcert, useUpdateConcert } from '@/hooks';
import { CreateConcertRequest } from '@/types/model';
import ConcertForm from '@/components/forms/ConcertForm';
import Button from '@/components/ui/Button.tsx';
import toast from 'react-hot-toast';

const EditConcert = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: concert, isLoading, isError, error } = useConcert(id!);
  const updateConcertMutation = useUpdateConcert();

  const handleSuccess = async (data: CreateConcertRequest) => {
    try {
      await updateConcertMutation.mutateAsync({ id: id!, data });
      toast.success('Concert updated successfully');
      navigate(-1);
    } catch (error) {
      console.error('Update error:', error);
      toast.error(error instanceof Error ? error.message : 'Unexpected error');
      throw error; // Re-throw to let form handle the error
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600"></div>
          </div>
        </div>
      </div>
    );
  }

  if (isError || !concert) {
    return (
      <div className="min-h-screen bg-gray-50 py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-red-50 border border-red-200 rounded-md p-4">
            <p className="text-sm text-red-600">
              {error instanceof Error ? error.message : 'Error al cargar el concierto'}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 py-4">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Button
            onClick={handleCancel}
            variant="link"
          >
            ← Volver a la lista
          </Button>

        <ConcertForm
          onSuccess={handleSuccess}
          onCancel={handleCancel}
          initialData={concert}
          isEdit={true}
          isSubmitting={updateConcertMutation.isPending}
        />
      </div>
    </div>
  );
};

export default EditConcert;
